module.exports = __webpack_public_path__ + "static/media/city_program_img.c996bebf.png";